import { init } from './init';
import * as ecodeLib from './sdk';
import libVersion from './libVersion';
import RouterMainSelf from "./RouterMain";
import './utils/helper';
init();

export { ready, loadAsyncReady } from './init';
export const version = libVersion;
export const { asyncImport, jsonp, relative, asyncImportPlugin } = ecodeLib;

export function RouterMain(props:any){
    return <RouterMainSelf weId={`_ci36fd`} isChildRoute {...props}/>
}
export { lazyPureVueInReact,lazyReactInVue,lazyPureReactInVue,lazyVueInReact,applyPureReactInVue,applyVueInReact,applyPureVueInReact,applyReactInVue,lazyReact}  from './vue/reactVue';

export {default as pluginManager} from './pluginManager';
export {default as vueRouter}  from './vue/vueRouter';